import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  getQuizCategoriesQuestions,
  offerEvent,
  submitQuestions,
} from "../../../utils/api";
import { ErrorHandling } from "../../../State";
import Header from "./Header";
import SubmitUserDetails from "../../Login/component/SubmitUserDetails";
import fpCoin from "../../../icons/coin.svg";
import { fanduBannerImgUrl } from "../../../utils/config";
import style from "../css/RandomQuestions.module.css";
import { SoftHeader } from "./RandomQuestions";
import UAParser from "ua-parser-js";
import { useParams } from "react-router-dom";

const QUIZ_DURATION_SECONDS = 60;
const shuffle = (items) => [...items].sort(() => Math.random() - 0.5);

function RakhiQuiz() {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [quizId, setQuizId] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [secondsLeft, setSecondsLeft] = useState(QUIZ_DURATION_SECONDS);
  const [loading, setLoading] = useState(true);
  const [hasEnded, setHasEnded] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showLoginPage, setShowLoginPage] = useState(false);
  const answersRef = useRef([]);
  const [bannerData, setBannerData] = useState(null);

  const [showSubmittedPopup, setShowSubmittedPopup] = useState(false);

  const { category } = useParams();
  const hasSubmittedRef = useRef(false);

  const machineId = localStorage.getItem("mId") || "2026";
  const fanduUserId = localStorage.getItem("fanduUserId");
  const currentQuestion = questions[currentQuestionIndex];

  let mId = localStorage.getItem("mId") || "2026";

  let uuid = localStorage.getItem("uuid");

  let sessionId = localStorage.getItem("session_id");

  const offerRequestData = (eventMetaData) => {
    try {
      const parser = new UAParser();
      const result = parser.getResult();

      return {
        machine_id: machineId || "",
        device_id: uuid || "",
        session_id: sessionId || "",
        user_id: localStorage.getItem("userId") || "",
        ip_address: localStorage.getItem("ip_address") || "",
        lat: "",
        lng: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        deviceBrand: result?.device?.vendor || "Unknown",
        deviceModel: result?.device?.model || "Unknown",
        deviceType: result?.device?.type || "desktop",
        osName: result?.os?.name || "Unknown",
        osVersion: result?.os?.version || "Unknown",
        browserName: result?.browser?.name || "Unknown",
        browserVersion: result?.browser?.version || "Unknown",
        event_ts: Date.now().toString(),
        ...eventMetaData,
      };
    } catch (error) {
      console.log("Analytics payload error:", error);
      return null;
    }
  };

  const trackEvent = async ({
    Event_Name,
    Event_Sub_Name = "Janmashtmi_Contest",
    Event_Type = "Screen_Impressions",
    Event_Sub_Type = "",
    Event_MetaData = {},
  }) => {
    try {
      const requestData = offerRequestData({
        Event_Name,
        Event_Sub_Name,
        Event_Type,
        Event_Sub_Type,
        Event_MetaData,
      });

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      console.log("Analytics Event Error:", error);
    }
  };

  useEffect(() => {
    trackEvent({
      Event_Name: "Fandu_Janmashtmi_Contest_Quiz",
      Event_Sub_Name: category,
      Event_Type: "Page_Open",
      Event_Sub_Type: "Janmashtmi_Quiz_Page",
    });
  }, []);

  useEffect(() => {
    if (!hasEnded) return;

    trackEvent({
      Event_Name: "Fandu_Janmashtmi_Contest_Submit",
      Event_Sub_Name: "Janmashtmi_Quiz_Submit",
      Event_Type: "Screen_Impressions",
      Event_Sub_Type: "Quiz_Completed",
    });
  }, [hasEnded, quizId, questions.length]);

  useEffect(() => {
    const loadQuestions = async () => {
      try {
        const response = await getQuizCategoriesQuestions(
          category,
          fanduUserId,
        );
        const data = response.data.Category.banner_img;
        const quizQuestions = response?.data?.questions || [];

        if (!response?.success || quizQuestions.length === 0) {
          ErrorHandling(
            response?.message ||
              "Unable to load Janmashtmi quiz questions. Please try again.",
          );
          return;
        }

        const fetchedQuizId = quizQuestions[0]?.quiz_id;

        setQuestions(shuffle(quizQuestions));
        setBannerData(data);
        setQuizId(fetchedQuizId);

        localStorage.setItem("rakhiQuizId", fetchedQuizId);
      } catch (error) {
        ErrorHandling(error?.message || "Unable to load Rakhi quiz questions.");
      } finally {
        setLoading(false);
      }
    };

    loadQuestions();
  }, [category]);

  const submitRakhiQuiz = async () => {
    if (submitting) return;

    const finalQuizId = quizId || localStorage.getItem("rakhiQuizId");
    console.log("first");

    if (!finalQuizId) {
      ErrorHandling("Quiz ID is missing.");
      return false;
    }

    try {
      setSubmitting(true);

      const payload = {
        user_id: fanduUserId,
        quiz_id: finalQuizId,
        responses: answersRef.current,
      };

      const response = await submitQuestions(payload);

      if (!response?.success) {
        ErrorHandling(
          response?.message || "Unable to submit quiz. Please try again.",
        );

        return false;
      }

      // Optional: update points if API returns score
      if (response?.total_score !== undefined) {
        localStorage.setItem("userFanduPoints", response.total_score);
      }

      return true;
    } catch (error) {
      console.error("Rakhi quiz submit error:", error);

      ErrorHandling(error?.message || "Unable to submit Rakhi quiz.");

      return false;
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (loading || hasEnded || questions.length === 0) return undefined;

    const timer = window.setInterval(() => {
      setSecondsLeft((remaining) => {
        if (remaining <= 1) {
          window.clearInterval(timer);
          setHasEnded(true);
          return 0;
        }

        return remaining - 1;
      });
    }, 1000);

    return () => window.clearInterval(timer);
  }, [hasEnded, loading, questions.length]);

  useEffect(() => {
    if (!hasEnded || fanduUserId || !quizId) return;

    localStorage.setItem(
      "selectedAnswers",
      JSON.stringify({ quiz_id: quizId, responses: answersRef.current }),
    );
  }, [hasEnded, fanduUserId, quizId]);

  useEffect(() => {
    if (!hasEnded) return;

    if (hasSubmittedRef.current) return;

    const handleQuizEnd = async () => {
      // Not logged in
      if (!fanduUserId) {
        const finalQuizId = quizId || localStorage.getItem("rakhiQuizId");

        const payload = {
          quiz_id: finalQuizId,
          responses: answersRef.current,
        };

        localStorage.setItem("selectedAnswers", JSON.stringify(payload));

        setShowLoginPage(true);

        return;
      }

      // Prevent duplicate API calls
      hasSubmittedRef.current = true;

      const submitted = await submitRakhiQuiz();

      if (!submitted) {
        hasSubmittedRef.current = false;

        return;
      }
      markQuizAsPlayed();

      setShowSubmittedPopup(true);

      setTimeout(() => {
        setShowSubmittedPopup(false);
        navigate("/janmashtmi-contest/");
      }, 2000);
    };

    handleQuizEnd();
  }, [hasEnded, fanduUserId, quizId]);

  const handleOptionClick = (optionIndex) => {
    if (hasEnded || selectedOption !== null || !currentQuestion) return;

    const answer = {
      question_id: currentQuestion.id,
      selected_option_id: currentQuestion.question_options[optionIndex].id,
    };
    trackEvent({
      Event_Name: "Fandu_Janmashtmi_Contest_Quiz",
      Event_Sub_Name: `Question ${currentQuestionIndex + 1}`,
      Event_Type: "Click",
      Event_Sub_Type: "Option_Selected",

      Event_MetaData: {
        quiz_id: quizId,
        question_id: currentQuestion.id,
        question_number: currentQuestionIndex + 1,
        option_id: currentQuestion.question_options[optionIndex].id,
      },
    });
    const updatedAnswers = [
      ...answers.filter((item) => item.question_id !== answer.question_id),
      answer,
    ];

    answersRef.current = updatedAnswers;
    setAnswers(updatedAnswers);
    setSelectedOption(optionIndex);

    const payload = {
      user_id: fanduUserId || "",
      quiz_id: localStorage.getItem("rakhiQuizId"),
      responses: updatedAnswers,
    };
    localStorage.setItem("selectedAnswers", JSON.stringify(payload));

    window.setTimeout(() => {
      setSelectedOption(null);
      setCurrentQuestionIndex((index) => (index + 1) % questions.length);
    }, 350);
  };

  const markQuizAsPlayed = () => {
    const contestId =
      category === "contest1" ? 1 : category === "contest2" ? 5 : null;

    if (!contestId) return;
    const existing = JSON.parse(
      localStorage.getItem("rakhiPlayedContests") || "{}",
    );

    existing[String(contestId)] = true;

    localStorage.setItem("rakhiPlayedContests", JSON.stringify(existing));
  };

  if (loading) {
    return (
      <div className={style.loaderWrapper}>
        <div className={style.loader} />
      </div>
    );
  }

  const handleLoginSubmit = () => navigate("/janmashtmi-contest/");

  return (
    <div className={style.page}>
      <Header
        title="noArrow"
        path={`/vm/${machineId}/`}
        fanduPoints={localStorage.getItem("userFanduPoints") || "0"}
      />
      <div className={style.questionScreen}>
        <SoftHeader />
        <div className={style.viewport}>
          <AnimatePresence mode="sync">
            <motion.div
              key={`${showLoginPage ? "login" : "question"}-${currentQuestionIndex}`}
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "-100%" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              style={{ position: "absolute", inset: 0, width: "100%" }}
            >
              {showLoginPage ? (
                <SubmitUserDetails
                  isNavigate
                  onSubmit={handleLoginSubmit}
                  isContest={true}
                />
              ) : (
                <QuestionScreen
                  currentQuestion={currentQuestion}
                  currentQuestionIndex={currentQuestionIndex}
                  handleOptionClick={handleOptionClick}
                  secondsLeft={secondsLeft}
                  selectedOption={selectedOption}
                  bannerData={bannerData}
                />
              )}
            </motion.div>
          </AnimatePresence>
        </div>
        {showSubmittedPopup && (
          <div className={style.popupOverlay}>
            <div className={style.submitPopup}>
              <div className={style.successIcon}>🎉</div>

              <h3>Quiz Submitted!</h3>

              <span>Your Janmashtami quiz responses have been saved.</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RakhiQuiz;

function QuestionScreen({
  currentQuestion,
  currentQuestionIndex,
  handleOptionClick,
  secondsLeft,
  selectedOption,
  bannerData,
}) {
  const questionThemes = [
    { card: "linear-gradient(180deg, #23003B, #42005D)", accent: "#FF4D8D" },
    { card: "linear-gradient(180deg, #003B2E, #00664F)", accent: "#2DD4BF" },
    { card: "linear-gradient(180deg, #3B2300, #7A4B00)", accent: "#F59E0B" },
    { card: "linear-gradient(180deg, #0B2E6B, #1E4ED8)", accent: "#60A5FA" },
    { card: "linear-gradient(180deg, #5B0023, #A10045)", accent: "#F472B6" },
    { card: "linear-gradient(180deg, #2E1065, #5B21B6)", accent: "#A78BFA" },
  ];
  const theme = questionThemes[currentQuestionIndex % questionThemes.length];

  return (
    <>
      <div className={style.bannerSection}>
        <img
          src={`${fanduBannerImgUrl}/${bannerData}`}
          className={style.banner}
          alt="Janmashtami quiz"
        />
      </div>
      <div className={style.bottomSection}>
        <div className={style.rewardBanner}>
          <img src={fpCoin} alt="" />
          <span>1 point for each question. {secondsLeft}s left</span>
        </div>
        <div className={style.questionCard} style={{ background: theme.card }}>
          <h2 className={style.questionText}>
            {currentQuestion?.question_text}
          </h2>
          <div className={style.options} style={{ color: theme.accent }}>
            {currentQuestion?.question_options?.map((option, index) => (
              <div
                key={option.id}
                className={`${style.option} ${selectedOption === index ? style.selected : ""}`}
                onClick={() => handleOptionClick(index)}
                onPointerDown={(event) => event.stopPropagation()}
              >
                <div
                  className={`${style.optionLetter} ${selectedOption === index ? style.selectedChar : style.nonSelectChar}`}
                  style={{ backgroundColor: theme.accent }}
                >
                  {String.fromCharCode(65 + index)}
                </div>
                <span>{option.option_text}</span>
                {selectedOption === index && (
                  <div className={style.tick}>✓</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
